import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState('verifying');
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setState('missing'); return; }
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch('/api/signup/verify-email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const body = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (res.ok) {
          setState('ok');
        } else {
          setState('error');
          setDetail(body.error || `HTTP ${res.status}`);
        }
      } catch (err) {
        if (!cancelled) { setState('error'); setDetail(err.message); }
      }
    })();
    return () => { cancelled = true; };
  }, [params]);

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Email verification</h1>
        {state === 'verifying' && <p>Confirming your email…</p>}
        {state === 'missing' && (
          <p className="login-error">No verification token in the URL. Check the link in your email.</p>
        )}
        {state === 'ok' && (
          <>
            <p>Email verified. You can keep using Markaii without interruption.</p>
            <Link to="/dashboard" className="btn btn-primary">Continue to dashboard</Link>
          </>
        )}
        {state === 'error' && (
          <>
            <p className="login-error">Could not verify: {detail}</p>
            <p>This link may have already been used, or it expired. Request a new one from <Link to="/account">your account</Link>.</p>
          </>
        )}
      </div>
    </div>
  );
}
